import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { ButtonSizing, ButtonVariant } from './types'
import { useSettingsStore } from '@/store/settings'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicButton',
  props: {
    text: null,
    variant: { default: ButtonVariant.LightOutline },
    sizing: { default: ButtonSizing.Default }
  },
  setup(__props: any) {

const props = __props as { text?: string, variant: ButtonVariant, sizing: ButtonSizing }


const settingsStore = useSettingsStore()

const styleMapping = {
  lightOutline: {
    text: 'text-white md:text-slate-20',
    stroke: 'stroke-white md:stroke-slate-20',
    border: 'border-solid border-2 border-stone',
    fill: '',
    shadow: '',
  },
  darkOutline: {
    text: 'text-slateGray',
    stroke: '',
    border: 'border-solid border-2 border-slateGray',
    fill: '',
    shadow: '',
  },
  filled: {
    text: 'text-slateGray',
    stroke: '',
    border: '',
    fill: 'bg-poppy',
    shadow: 'drop-shadow',
  },
  filledOutline: {
    text: 'text-white',
    stroke: '',
    border: 'border-solid border-2 border-white',
    fill: 'bg-poppy',
    shadow: '',
  },
}

const styleMappingHighContrast = {
  lightOutline: {
    text: 'text-charcoalGray',
    stroke: 'stroke-charcoalGray',
    border: '',
    fill: 'bg-white',
    shadow: '',
  },
  darkOutline: {
    text: 'text-charcoalGray',
    stroke: '',
    border: 'border-solid border-2 border-slateGray',
    fill: 'bg-white',
    shadow: '',
  },
  filled: {
    text: 'text-slate-tone',
    stroke: '',
    border: '',
    fill: 'bg-poppy',
    shadow: 'drop-shadow',
  },
  filledOutline: {
    text: 'text-white',
    stroke: '',
    border: 'border-solid border-2 border-white',
    fill: 'bg-poppy',
    shadow: '',
  },
}

const currentStyleMapping = computed(() => {
  return settingsStore.highContrast ? styleMappingHighContrast : styleMapping
})

const getVariantStyle = computed(() => {
  let style = currentStyleMapping.value[props.variant]
  if (!style) style = currentStyleMapping.value[ButtonVariant.LightOutline]
  let combinedStyle =
    style.text +
    ' ' +
    style.fill +
    ' ' +
    style.shadow +
    ' ' +
    getWrapperStyle.value +
    ' ' +
    getFontSize.value
  if (props.text) {
    combinedStyle += ' ' + style.border
  }
  return combinedStyle
})

const getVariantStroke = computed(() => {
  let style = currentStyleMapping.value[props.variant]
  if (!style) style = currentStyleMapping.value[ButtonVariant.LightOutline]
  return style.stroke
})

const getWrapperStyle = computed(() => {
  if (props.text) {
    if (props.sizing == ButtonSizing.Compact) {
      return 'rounded-xl py-5px px-3 gap-5px'
    } else {
      return 'rounded-xl py-2 px-15px gap-5px'
    }
  } else {
    return 'rounded-full w-10 h-10 p0'
  }
})

const getFontSize = computed(() => {
  if (props.sizing == ButtonSizing.Compact) {
    return 'text-bodyMd'
  } else {
    return 'text-base font-medium'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([_unref(getVariantStyle), "flex group justify-center items-center font-sans cursor-pointer"])
  }, [
    (!__props.text)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "icon"),
    _createElementVNode("span", null, _toDisplayString(__props.text), 1),
    (!__props.text)
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true)
  ], 2))
}
}

})